<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="none"
      stroke="currentColor"
      stroke-miterlimit="10"
      stroke-width="1.5"
      d="M2.76 3.45h18.07l-2.14 19.87H4.9L2.76 3.45z"
    />
    <path
      fill="none"
      stroke="currentColor"
      stroke-miterlimit="10"
      stroke-width="1.46"
      d="M0 3.38h23.99M7.35 3.45V.65h8.89v2.8"
    />
    <path
      fill="none"
      stroke="currentColor"
      stroke-miterlimit="10"
      stroke-width="1.5"
      d="m6.56 6.19 1.62 14.68M16.93 5.95l-1.65 14.91M11.8 6.19v14.17"
    />
    <path fill="none" d="M4.81 4.28h14.13v2.57H4.81zM6.28 20.36h11.2v1.44H6.28z" />
  </svg>
</template>
